import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

const LoadingTagReminder = ({
  classes,
  includeHorse,
  includeTask,
}) => (
  <TableRow
    className={classes.row}
    style={{ borderLeft: '4px solid inherit' }}
  >
    {
      includeHorse && (
        <TableCell className={classes.cell}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Skeleton variant="circular" width={36} height={36} sx={{ marginRight: 1 }} />
            <Skeleton
              variant="text"
              width={80}
              height={36}
              sx={{
                color: 'action.active',
                mr: 1,
                my: 0.5,
              }}
            />
          </Box>
        </TableCell>
      )
    }
    <TableCell className={classes.cellTasks} sx={{ p: 0 }}>
      <Skeleton
        variant="text"
        width="90%"
        height={55}
        sx={{
          borderRadius: 4,
          ml: 2,
          mr: 2,
        }}
      />
    </TableCell>
    <TableCell className={classes.cellSchedule} sx={{ p: 0 }}>
      <Skeleton
        variant="text"
        width="90%"
        height={55}
        sx={{
          borderRadius: 4,
          ml: 2,
          mr: 2,
        }}
      />
    </TableCell>
    <TableCell className={classes.cellSchedule} sx={{ p: 0 }}>
      <Skeleton
        variant="text"
        width="90%"
        height={55}
        sx={{
          borderRadius: 4,
          ml: 2,
          mr: 2,
        }}
      />
    </TableCell>
    <TableCell className={classes.cellSchedule} sx={{ p: 0 }}>
      <Skeleton
        variant="text"
        width="90%"
        height={55}
        sx={{
          borderRadius: 4,
          ml: 2,
          mr: 2,
        }}
      />
    </TableCell>
    {
      includeTask && (
        <TableCell className={classes.cellSchedule} sx={{ p: 0 }}>
          <Skeleton
            variant="text"
            width="90%"
            height={55}
            sx={{
              borderRadius: 4,
              ml: 2,
              mr: 2,
            }}
          />
        </TableCell>
      )
    }
  </TableRow>
);

LoadingTagReminder.propTypes = {
  classes: PropTypes.object,
  includeTask: PropTypes.bool,
  includeHorse: PropTypes.bool,
};

LoadingTagReminder.defaultProps = {
  classes: {},
  includeTask: false,
  includeHorse: true,
};

export default LoadingTagReminder;
